export default "__VITE_ASSET__RJBjB0oO__";